/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useCompanyApiKeysGetAll = makeQueryHook(
  operations.companyApiKeysGetAll,
)

export const useCompanyApiKeyCreate = makeMutationHook(
  operations.companyApiKeyCreate,
)

export const useCompanyApiKeyGet = makeQueryHook(operations.companyApiKeyGet)

export const useCompanyApiKeyUpdate = makeMutationHook(
  operations.companyApiKeyUpdate,
)

export const useCompanyApiKeyDelete = makeMutationHook(
  operations.companyApiKeyDelete,
)

export const useInternalCompanyApiKeysGetAll = makeQueryHook(
  operations.internalCompanyApiKeysGetAll,
)

export const useInternalCompanyApiKeyCreate = makeMutationHook(
  operations.internalCompanyApiKeyCreate,
)

export const useInternalCompanyApiKeyGet = makeQueryHook(
  operations.internalCompanyApiKeyGet,
)

export const useInternalCompanyApiKeyUpdate = makeMutationHook(
  operations.internalCompanyApiKeyUpdate,
)

export const useInternalCompanyApiKeyDelete = makeMutationHook(
  operations.internalCompanyApiKeyDelete,
)
